<template>
  <div class="sidenav-content-container">
    <div class="sidenav-content-frame" v-if="languageCode === 'ko'">
      <div class="sidenav-category-container" v-if="!isTestAccount">
        <div class="sidenav-category-items">
          <sidenav-item
            :componentName="RouterEnum.Dashboard.name"
            :class="getMenuStatus.equals.Dashboard"
            :navText="$t('side_nav_list_deshboard_text')"
          >
            <template v-slot:icon>
              <div
                class="menu-dashboard"
                :class="getMenuStatus.equals.Dashboard"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
      <div
        class="sidenav-category-container"
        v-if="permissions.hospitalSettings"
      >
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_brand_setting_text") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            :componentName="RouterEnum.BrandSetting.name"
            :class="getMenuStatus.equals.BrandSetting"
            :navText="$t('side_nav_list_hospital_setting_text')"
          >
            <template v-slot:icon>
              <div
                class="menu-brand-setting"
                :class="getMenuStatus.equals.BrandSetting"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
      <div
        class="sidenav-category-container"
        v-if="deptBoolean.hasDent && permissions.dentalCert"
      >
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_dent_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            :componentName="RouterEnum.DentIssueCertificate.name"
            :class="getMenuStatus.equals.DentIssueCertificate"
            :navText="$t('side_nav_list_dent_certificate_issue_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.DentIssueCertificate"
                class="menu-issue"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            :componentName="
              getDentCertificateSettingComponentName(deptBoolean.hasDent)
            "
            :class="getMenuStatus.includes.DentEditCertificateContents"
            :navText="$t('side_nav_list_dent_certificate_setting_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.includes.DentEditCertificateContents"
                class="menu-setting"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
      <div
        class="sidenav-category-container"
        v-if="deptBoolean.hasOph && permissions.ophCert"
      >
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_oph_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            :componentName="RouterEnum.OphIssueCertificate.name"
            :class="getMenuStatus.equals.OphIssueCertificate"
            :navText="$t('side_nav_list_oph_certificate_issue_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.OphIssueCertificate"
                class="menu-issue"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            :componentName="RouterEnum.OphBulkIssue.name"
            :class="getMenuStatus.equals.OphBulkIssue"
            :navText="$t('side_nav_list_oph_bulk_issue_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.OphBulkIssue"
                class="menu-bulk"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            :componentName="RouterEnum.OphEditCertificateContentsList.name"
            :class="getMenuStatus.includes.OphEditCertificateContentsList"
            :navText="$t('side_nav_list_oph_certificate_setting_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.includes.OphEditCertificateContentsList"
                class="menu-setting"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
      <div
        class="sidenav-category-container"
        v-if="deptBoolean.hasPs && permissions.plasticCert"
      >
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_ps_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            :componentName="RouterEnum.PsIssueCertificate.name"
            :class="getMenuStatus.equals.PsIssueCertificate"
            :navText="$t('side_nav_list_ps_certificate_issue_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.PsIssueCertificate"
                class="menu-issue"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            :componentName="RouterEnum.PsEditCertificateContents.name"
            :class="getMenuStatus.includes.PsEditCertificateContents"
            :props="{ params: { step: '1' } }"
            :navText="$t('side_nav_list_ps_certificate_setting_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.includes.PsEditCertificateContents"
                class="menu-setting"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
      <div
        class="sidenav-category-container"
        v-if="deptBoolean.hasDerm && permissions.dermaCert"
      >
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_derm_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            :componentName="RouterEnum.DermIssueCertificate.name"
            :class="getMenuStatus.equals.DermIssueCertificate"
            :navText="$t('side_nav_list_derm_certificate_issue_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.DermIssueCertificate"
                class="menu-issue"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            :componentName="RouterEnum.DermEditCertificateContents.name"
            :class="getMenuStatus.includes.DermEditCertificateContents"
            :navText="$t('side_nav_list_derm_certificate_setting_text')"
            :props="{ params: { step: '1' } }"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.includes.DermEditCertificateContents"
                class="menu-setting"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
      <div
        class="sidenav-category-container"
        v-if="deptBoolean.hasIm && permissions.internalCert"
      >
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_im_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            :componentName="RouterEnum.ImIssueCertificate.name"
            :class="getMenuStatus.equals.ImIssueCertificate"
            :navText="$t('side_nav_list_im_certificate_issue_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.ImIssueCertificate"
                class="menu-issue"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            :componentName="RouterEnum.ImEditCertificateContents.name"
            :class="getMenuStatus.includes.ImEditCertificateContents"
            :navText="$t('side_nav_list_im_certificate_setting_text')"
            :props="{ params: { step: '1' } }"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.includes.ImEditCertificateContents"
                class="menu-setting"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
      <div
        class="sidenav-category-container"
        v-if="deptBoolean.hasOs && permissions.orthoCert"
      >
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_os_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            :componentName="RouterEnum.OsIssueCertificate.name"
            :class="getMenuStatus.equals.OsIssueCertificate"
            :navText="$t('side_nav_list_os_certificate_issue_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.OsIssueCertificate"
                class="menu-issue"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            :componentName="RouterEnum.OsEditCertificateContents.name"
            :class="getMenuStatus.includes.OsEditCertificateContents"
            :navText="$t('side_nav_list_os_certificate_setting_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.includes.OsEditCertificateContents"
                class="menu-setting"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
      <div
        class="sidenav-category-container"
        v-if="deptBoolean.hasVet && permissions.vetCert"
      >
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_vet_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            :componentName="RouterEnum.VetIssueCertificate.name"
            :class="getMenuStatus.equals.VetIssueCertificate"
            :navText="$t('side_nav_list_vet_certificate_issue_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.VetIssueCertificate"
                class="menu-issue"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            :componentName="RouterEnum.VetEditCertificateContents.name"
            :class="getMenuStatus.includes.VetEditCertificateContents"
            :navText="$t('side_nav_list_vet_certificate_setting_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.includes.VetEditCertificateContents"
                class="menu-setting"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
      <div class="sidenav-category-container" v-if="permissions.generalCert">
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_common_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            :componentName="RouterEnum.CommonIssueCertificate.name"
            :class="getMenuStatus.equals.CommonIssueCertificate"
            :navText="$t('side_nav_list_common_certificate_issue_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.CommonIssueCertificate"
                class="menu-issue"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            :componentName="RouterEnum.CommonEditCertificateContents.name"
            :class="getMenuStatus.includes.CommonEditCertificateContents"
            :navText="$t('side_nav_list_common_certificate_setting_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.includes.CommonEditCertificateContents"
                class="menu-setting"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
      <div
        class="sidenav-category-container"
        v-if="
          onlyShowReservationMenuTestBedHospital &&
          permissions.reservationManagement
        "
      >
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_reservation_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            v-if="onlyShowReservationList && subMenu('reservationList')"
            :componentName="RouterEnum.ReservationList.name"
            :class="getMenuStatus.equals.ReservationList"
            :navText="$t('side_nav_list_reservation_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.ReservationList"
                class="menu-reservation-list"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            v-if="onlyShowReservationMenuTestBedHospital && subMenu('reviewManagement')"
            :componentName="RouterEnum.ReviewManagement.name"
            :class="getMenuStatus.equals.ReviewManagement"
            :navText="$t('side_nav_list_review_management_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.ReviewManagement"
                class="menu-review-management"
              />
            </template>
          </sidenav-item>
          <!-- <sidenav-item
                    :componentName="RouterEnum.BrowserNotification.name"
                    :class="getMenuStatus.equals.BrowserNotification"
                    navText="브라우저 알림 관리"
                >
                  <template v-slot:icon>
                    <div
                        :class="getMenuStatus.equals.BrowserNotification"
                        class="menu-browser-notification"
                    />
                  </template>
                </sidenav-item> -->
        </div>
      </div>
      <div
        class="sidenav-category-container"
        v-if="permissions.issuancePatientManagement"
      >
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_issue_patient_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            v-if="subMenu('certificateList')"
            :componentName="RouterEnum.CertificateList.name"
            :class="getMenuStatus.equals.CertificateList"
            :navText="$t('side_nav_list_certificate_list_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.CertificateList"
                class="menu-history"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            v-if="subMenu('customerList')"
            :componentName="RouterEnum.CustomerList.name"
            :class="getMenuStatus.equals.CustomerList"
            :navText="customerListSidenavText"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.CustomerList"
                class="menu-customers"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
      <div
        class="sidenav-category-container"
        v-if="
          deptBoolean.hasDent &&
          !isTestAccount &&
          (permissions.paymentHistory ||
            permissions.orderManagement ||
            permissions.electronicContract)
        "
      >
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_purchase_order_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            v-if="permissions.paymentHistory"
            :componentName="RouterEnum.Subscription.name"
            :class="getMenuStatus.equals.Subscription"
            :navText="$t('side_nav_list_subscription_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.Subscription"
                class="menu-orders"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            v-if="permissions.orderManagement"
            :componentName="RouterEnum.Order.Container.name"
            :class="getMenuStatus.equals.OrderContainer"
            :navText="$t('side_nav_list_order_text')"
            :isDentium="true"
            :isReady="true"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.OrderContainer"
                class="menu-orders"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            v-if="permissions.electronicContract"
            :componentName="RouterEnum.ContractManagement.ContractList.name"
            :class="getMenuStatus.equals.Contract"
            :navText="$t('side_nav_list_contract_text')"
            :isDentium="true"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.Contract"
                class="menu-contract"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
      <div
        class="sidenav-category-container"
        v-if="
          !isTestAccount &&
          (permissions.treatmentConsent ||
            permissions.laborContract ||
            permissions.hospitalInfo ||
            permissions.accountManagement)
        "
      >
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_hospital_management_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            v-if="permissions.treatmentConsent"
            :componentName="RouterEnum.ElectronicSign.ConsentContract.name"
            :class="getMenuStatus.equals.ConsentContract"
            :navText="$t('side_nav_list_consent_contract_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.ConsentContract"
                class="menu-contract"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            v-if="permissions.laborContract"
            :componentName="RouterEnum.ElectronicSign.LaborContract.name"
            :class="getMenuStatus.equals.LaborContract"
            :navText="$t('side_nav_list_labor_contract_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.LaborContract"
                class="menu-contract"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            v-if="permissions.hospitalInfo"
            :componentName="RouterEnum.HospitalInfo.name"
            :class="getMenuStatus.includes.HospitalInfo"
            :navText="$t('side_nav_list_hospital_info_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.includes.HospitalInfo"
                class="menu-hospital"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            v-if="permissions.accountManagement"
            :componentName="RouterEnum.SubAccountManagement.List.name"
            :class="getMenuStatus.includes.SubAccountManagement"
            :navText="$t('side_nav_list_sub_account_management_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.includes.SubAccountManagement"
                class="menu-account-management"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
      <div
        class="sidenav-category-container"
        v-if="!isTestAccount && permissions.alimtalkManagement"
      >
        <div class="sidenav-category-title">
          <span>알림톡</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            :componentName="RouterEnum.Alimtalk.ChannelSettings.name"
            :class="getMenuStatus.includes.AlimtalkChannelSettings"
            navText="채널 설정"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.includes.AlimtalkChannelSettings"
                class="menu-alimtalk-channel"
              />
            </template>
          </sidenav-item>
          <div
            class="sidenav-item-container"
            :class="[
              getMenuStatus.equals.AlimtalkTemplateList,
              { disabled: !hasPrimaryChannel },
            ]"
            @click="
              handleAlimtalkMenuClick(RouterEnum.Alimtalk.TemplateList.name)
            "
          >
            <div class="sidenav-item-icon">
              <div
                :class="getMenuStatus.equals.AlimtalkTemplateList"
                class="menu-alimtalk-list"
              />
            </div>
            <div class="sidenav-item-text">템플릿 조회</div>
          </div>
          <div
            class="sidenav-item-container"
            :class="[
              getMenuStatus.equals.AlimtalkTemplateCreate,
              { disabled: !hasPrimaryChannel },
            ]"
            @click="
              handleAlimtalkMenuClick(RouterEnum.Alimtalk.TemplateCreate.name)
            "
          >
            <div class="sidenav-item-icon">
              <div
                :class="getMenuStatus.equals.AlimtalkTemplateCreate"
                class="menu-alimtalk-template"
              />
            </div>
            <div class="sidenav-item-text">템플릿 등록</div>
          </div>
          <div
            class="sidenav-item-container"
            :class="[
              getMenuStatus.equals.AlimtalkTemplateBulkCreate,
              { disabled: !hasPrimaryChannel },
            ]"
            @click="
              handleAlimtalkMenuClick(
                RouterEnum.Alimtalk.TemplateBulkCreate.name
              )
            "
          >
            <div class="sidenav-item-icon">
              <div
                :class="getMenuStatus.equals.AlimtalkTemplateBulkCreate"
                class="menu-alimtalk-bulk"
              />
            </div>
            <div class="sidenav-item-text">템플릿 대량 등록</div>
          </div>
        </div>
      </div>
      <div
        class="sidenav-category-container"
        v-if="
          !isTestAccount &&
          permissions.counselingChatbotManagement &&
          (subMenu('studioChatbot') || subMenu('studioCounsel') || hasVoicebotAccess)
        "
      >
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_chatbot_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <div v-if="subMenu('studioChatbot')" class="sidenav-item-container" @click="goToStudio('chatbots')">
            <div class="sidenav-item-icon">
              <div class="menu-chatbot-management" />
            </div>
            <div class="sidenav-item-text">
              {{ $t("side_nav_list_chatbot_management_text") }}
            </div>
          </div>
          <div v-if="subMenu('studioCounsel')" class="sidenav-item-container" @click="goToStudio('counsel')">
            <div class="sidenav-item-icon">
              <div class="menu-counsel-management" />
            </div>
            <div class="sidenav-item-text">
              {{ $t("side_nav_list_counsel_management_text") }}
            </div>
          </div>
          <div
            v-if="hasVoicebotAccess"
            class="sidenav-item-container"
            @click="goToVoicebotAdmin"
          >
            <div class="sidenav-item-icon">
              <div class="menu-voicebot-management" />
            </div>
            <div class="sidenav-item-text">
              {{ $t("side_nav_list_voicebot_management_text") }}
            </div>
          </div>
        </div>
      </div>
      <div class="sidenav-category-container" v-if="!isTestAccount">
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_guide_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            :outerPath="Constants.otherUrl.dashboardGuideUrl"
            :navText="$t('side_nav_list_user_guide_text')"
          >
            <template v-slot:icon>
              <div
                :src="require('@/assets/img/sidenav/guide.svg')"
                class="menu-guide"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            :componentName="RouterEnum.Notices.name"
            :class="getMenuStatus.includes.Notices"
            :navText="$t('side_nav_list_notices_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.includes.Notices"
                class="menu-notice"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
    </div>
    <div class="sidenav-content-frame" v-else-if="languageCode === 'zh'">
      <div class="sidenav-category-container" v-if="deptBoolean.hasDent">
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_dent_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            :componentName="RouterEnum.DentIssueCertificate.name"
            :class="getMenuStatus.equals.DentIssueCertificate"
            :navText="$t('side_nav_list_dent_certificate_issue_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.DentIssueCertificate"
                class="menu-issue"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            :componentName="`${RouterEnum.DentEditCertificateContents.name}${RouterEnum.Zh.name}`"
            :class="getMenuStatus.includes.DentEditCertificateContents"
            :navText="$t('side_nav_list_dent_certificate_setting_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.includes.DentEditCertificateContents"
                class="menu-setting"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
    </div>
    <div class="sidenav-content-frame" v-else-if="languageCode === 'ja'">
      <div class="sidenav-category-container" v-if="deptBoolean.hasDent">
        <div class="sidenav-category-title">
          <span>{{ $t("side_nav_list_dent_title") }}</span>
        </div>
        <div class="sidenav-category-items">
          <sidenav-item
            :componentName="`${RouterEnum.DentIssueCertificate.name}${RouterEnum.Ja.name}`"
            :class="getMenuStatus.equals.DentIssueCertificateJa"
            :navText="$t('side_nav_list_dent_certificate_issue_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.equals.DentIssueCertificateJa"
                class="menu-issue"
              />
            </template>
          </sidenav-item>
          <sidenav-item
            :componentName="`${RouterEnum.DentEditCertificateContents.name}${RouterEnum.Ja.name}`"
            :class="getMenuStatus.includes.DentEditCertificateContentsJa"
            :navText="$t('side_nav_list_dent_certificate_setting_text')"
          >
            <template v-slot:icon>
              <div
                :class="getMenuStatus.includes.DentEditCertificateContentsJa"
                class="menu-setting"
              />
            </template>
          </sidenav-item>
        </div>
      </div>
    </div>
    <!-- 지원 탭에서는 QR 로그인(앱 링크) 창을 열지 않음 — 서버가 서브 계정의 QR 만들기를 거절(W6 C3) -->
    <button
      class="bottom-app-download-btn"
      v-if="deptBoolean.hasDent && !isTestAccount && !supportTab"
      @click="modalHandler('qrLoginModal', true)"
    >
      <img src="@/assets/img/app-download-img.png" />
    </button>
  </div>
  <qr-login-modal :showModal="isQrModalShowing" @close-modal="modalHandler" />
</template>
<script>
import { getAccessToken, getProfile } from "@/utils/tokenStore";
import SidenavItem from "./SidenavItem.vue";
import {
  convertProfile,
  getAvailableSurgeryTypes,
  jwtDecoder,
} from "@/utils/utils";
import { MedicalDept } from "@/enums/common.enums";
import { Constants } from "@/utils/constants";
import { RouterEnum } from "@/router/router.enums";
import QrLoginModal from "@/views/components/QrLoginModal.vue";
import {
  openVoicebotAdmin,
  checkVoicebotAccess,
} from "@/services/voicebotSso.service";
import alimtalkChannelService from "@/services/alimtalkChannel.service";
import { isSupportTab } from "@/utils/tokenStore";
import { alreadyNotified } from "@/utils/mfa";
import { openStudio } from "@/services/handoff.service";
import { permState, loadPerms, reportPermUiDiffs } from "@/services/permState";
import { MENU_PERMS, menuAllowed, permUiDiffs, shouldUseNewRule, callAllowed, subMenuVisible } from "@/utils/permUi";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      navWidth: "calc(100% - 220px)",
      navWidthOri: "calc(100% + 220px)",
      openAppDownloadModal: false,
      isOpen: false,
      deptBoolean: {},
      MedicalDept,
      RouterEnum,
      Constants,
      shouldShowDentiumMenu: false,
      isQrModalShowing: false,
      isAppDownloadModalShowing: false,
      isTestAccount: false,
      companyInfo: {},
      hasVoicebotAccess: false,
      hasPrimaryChannel: false,
      // 지원 탭인지는 탭이 열릴 때 정해짐(교환 뒤 새로 고침)
      supportTab: isSupportTab(),
      permState,
    };
  },
  components: {
    SidenavItem,
    QrLoginModal,
  },
  async mounted() {
    if (getAccessToken())
      this.$store.dispatch("getCompanyInfo");

    this.$store.watch(
      () => this.$store.getters.getDeptBoolean,
      (value) => {
        this.companyInfo = this.$store.getters.getHospitalInfo;
        this.deptBoolean = value;
      }
    );
    this.$store.watch(
      () => this.$store.getters.getHospitalInfo,
      (value) => {
        this.companyInfo = value;
      }
    );

    if (this.$i18n.locale === "ja") {
      this.isTestAccount = true;
    } else {
      this.isTestAccount = false;
    }

    // 화면 권한 값(introspect). log 동안은 옛 규칙으로 그리고 다르면 보고만(W6 C7).
    // 숨긴 메뉴의 상태 확인은 보내지 않으려고 먼저 읽는다(거부가 이용 내역에 남음, 10-30 I10)
    await loadPerms();
    const companyId = jwtDecoder(getAccessToken());
    if (companyId && this.subMenu("voicebot")) {
      this.hasVoicebotAccess = await checkVoicebotAccess(companyId);
    }

    if (callAllowed(permState.modes, permState.perms, MENU_PERMS.alimtalkManagement.codes)) this.checkPrimaryChannel();
  },
  watch: {
    // 옛 규칙(회사 정보의 accountPermission)과 새 규칙(introspect perms)이 둘 다 오면 비교해 다른 메뉴를 보고
    permUiDiffList(diffs) {
      if (diffs.length) reportPermUiDiffs(diffs);
    },
  },
  computed: {
    // 메뉴 보임: permMode 가 enforce 인 날만 새 규칙, 그 전(log·off·모름)엔 옛 규칙 그대로 — 이번 배포에서 보이는 메뉴는 바뀌지 않음.
    // 라우터가 같은 menuAllowed 로 주소 이동을 막음(permUi.routeDenial)
    permissions() {
      const legacy = this.$store.getters.getPermissions;
      return Object.fromEntries(
        Object.keys(legacy).map((key) => [key, menuAllowed(key, { legacy, perms: permState.perms, modes: permState.modes })])
      );
    },
    permUiDiffList() {
      const legacy = this.$store.getters.getPermissions;
      // 회사 정보를 받기 전(accountType null)·enforce 날·perms 없음 → 비교하지 않음
      if (this.$store.state.accountPermission?.accountType == null) return [];
      if (shouldUseNewRule(permState.modes, permState.perms)) return [];
      // 진료과(deptBoolean)는 회사 속성이라 권한 비교에서 뺌. 예약 메뉴는 회사 id 숨김까지 옛 값에 넣어 비교(perm.md 3-3)
      const legacyByKey = {
        ...legacy,
        reservationManagement: this.onlyShowReservationMenuTestBedHospital && legacy.reservationManagement,
      };
      return permUiDiffs({ legacyByKey, perms: permState.perms, screen: "sidenav" });
    },
    isDevelopmentEnvironment() {
      return (
        process.env.NODE_ENV === "development" ||
        process.env.NODE_ENV === "local"
      );
    },
    languageCode() {
      if (this.$i18n.locale === "ja") return "ja";
      return "ko";
    },
    customerListSidenavText() {
      if (
        this.companyInfo &&
        this.companyInfo.medicalDept &&
        this.companyInfo.medicalDept.indexOf(MedicalDept.VET_COMMON) !== -1
      ) {
        return this.$t("side_nav_list_customer_list_vet_text");
      }
      return this.$t("side_nav_list_customer_list_text");
    },
    getDentEditCertificateContentsMenuStatus() {
      return (
        this.getRoutePath().includes(RouterEnum.Dent.path) &&
        (this.getRouteName() ===
          RouterEnum.DentEditCertificateContentsList.name ||
          this.getRouteName() === RouterEnum.DentEditCertificateContents.name ||
          this.getRouteName() ===
            RouterEnum.DentBraceEditCertificateContents.name ||
          this.getRouteName() ===
            RouterEnum.DentAbutmentEditCertificateContents.name ||
          this.getRouteName() ===
            RouterEnum.DentZirconiaEditCertificateContents.name)
      );
    },
    onlyShowReservationMenuTestBedHospital() {
      const companyId = jwtDecoder(getAccessToken());
      // 병원예약 메뉴 비활성화
      // 더밝은안과:6527681ff9d81b753d0f4d3c (잠시 활성화)
      // BGN밝은눈안과병원: 651e679a362cd2325fd04d58
      // BGN밝은눈안과: 65278430f9d81b753d0f50ff
      if (
        ["651e679a362cd2325fd04d58", "65278430f9d81b753d0f50ff"].includes(
          companyId
        )
      ) {
        return false;
      }
      // 개발 환경에서만 노출, 프로덕션에서는 기존 로직 유지
      // if (process.env.NODE_ENV !== 'production') {
      //     return true;
      // }
      // 프로덕션 환경에서는 기존 로직 유지
      // const hospitalName = localStorage.getItem('hospitalNameHos')
      // if (hospitalName.includes('테스트')) {
      //     return true;
      // }
      // if (hospitalName.includes('서티치과')) {
      //     return true;
      // }
      // if (hospitalName.includes('편한치과')) {
      //     return true;
      // }
      // return this.deptBoolean.hasOph;
      return true;
    },
    onlyShowReservationList() {
      // 개발 환경에서만 노출, 프로덕션에서는 기존 로직 유지
      // if (process.env.NODE_ENV !== 'production') {
      //     return true;
      // }
      // const hospitalName = localStorage.getItem('hospitalNameHos')
      // if (hospitalName.includes('테스트')) {
      //     return true;
      // }
      // if (hospitalName.includes('서티치과')) {
      //     return true;
      // }
      // if (hospitalName.includes('편한치과')) {
      //     return true;
      // }
      return true;
    },
    onlyShowConsentMenuTestBedHospital() {
      try {
        const hospitalName = getProfile("hospitalNameHos");
        if (hospitalName) {
          if (hospitalName === "편한치과") return true;
          if (hospitalName.includes("[테스트]")) return true;
        }
        if (this.companyInfo) {
          if (this.companyInfo.isTestCompany === "Y") return true;
        }

        return false;
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    getMenuStatus() {
      return {
        equals: {
          Dashboard:
            this.getRouteName() === RouterEnum.Dashboard.name ? "active" : "",
          BrandSetting:
            this.getRouteName() === RouterEnum.BrandSetting.name
              ? "active"
              : "",
          DentIssueCertificate:
            this.getRouteName() === RouterEnum.DentIssueCertificate.name
              ? "active"
              : "",
          DentIssueCertificateZh:
            this.getRouteName() ===
            `${RouterEnum.DentIssueCertificate.name}${RouterEnum.Zh.name}`
              ? "active"
              : "",
          DentIssueCertificateJa:
            this.getRouteName() ===
            `${RouterEnum.DentIssueCertificate.name}${RouterEnum.Ja.name}`
              ? "active"
              : "",
          OphIssueCertificate:
            this.getRouteName() === RouterEnum.OphIssueCertificate.name
              ? "active"
              : "",
          Subscription:
            this.getRoutePath() === RouterEnum.Subscription.path
              ? "active"
              : "",
          OphBulkIssue:
            this.getRouteName() === RouterEnum.OphBulkIssue.name
              ? "active"
              : "",
          PsIssueCertificate:
            this.getRouteName() === RouterEnum.PsIssueCertificate.name
              ? "active"
              : "",
          DermIssueCertificate:
            this.getRouteName() === RouterEnum.DermIssueCertificate.name
              ? "active"
              : "",
          ImIssueCertificate:
            this.getRouteName() === RouterEnum.ImIssueCertificate.name
              ? "active"
              : "",
          OsIssueCertificate:
            this.getRouteName() === RouterEnum.OsIssueCertificate.name
              ? "active"
              : "",
          CommonIssueCertificate:
            this.getRouteName() === RouterEnum.CommonIssueCertificate.name
              ? "active"
              : "",
          VetIssueCertificate:
            this.getRouteName() === RouterEnum.VetIssueCertificate.name
              ? "active"
              : "",
          CertificateList:
            this.getRouteName() === RouterEnum.CertificateList.name
              ? "active"
              : "",
          CustomerList:
            this.getRouteName() === RouterEnum.CustomerList.name
              ? "active"
              : "",
          OrderContainer:
            this.getRouteName() === RouterEnum.Order.Container.name
              ? "active"
              : "",
          Contract:
            this.getRouteName() ===
            RouterEnum.ContractManagement.ContractList.name
              ? "active"
              : "",
          ReservationList:
            this.getRouteName() === RouterEnum.ReservationList.name
              ? "active"
              : "",
          BrowserNotification:
            this.getRouteName() === RouterEnum.BrowserNotification.name
              ? "active"
              : "",
          LaborContract:
            this.getRouteName() === RouterEnum.ElectronicSign.LaborContract.name
              ? "active"
              : "",
          ConsentContract:
            this.getRouteName() ===
            RouterEnum.ElectronicSign.ConsentContract.name
              ? "active"
              : "",
          ReviewManagement:
            this.getRouteName() === RouterEnum.ReviewManagement.name
              ? "active"
              : "",
          AlimtalkChannelSettings:
            this.getRouteName() === RouterEnum.Alimtalk.ChannelSettings.name
              ? "active"
              : "",
          AlimtalkTemplateCreate:
            this.getRouteName() === RouterEnum.Alimtalk.TemplateCreate.name
              ? "active"
              : "",
          AlimtalkTemplateList:
            this.getRouteName() === RouterEnum.Alimtalk.TemplateList.name
              ? "active"
              : "",
          AlimtalkTemplateBulkCreate:
            this.getRouteName() === RouterEnum.Alimtalk.TemplateBulkCreate.name
              ? "active"
              : "",
        },
        includes: {
          DentEditCertificateContentsList: this
            .getDentEditCertificateContentsMenuStatus
            ? "active"
            : "",
          DentEditCertificateContents: this
            .getDentEditCertificateContentsMenuStatus
            ? "active"
            : "",
          DentEditCertificateContentsZh:
            this.getRoutePath().includes(RouterEnum.Dent.path) &&
            this.getRouteName() ===
              `${RouterEnum.DentEditCertificateContents.name}${RouterEnum.Zh.name}`
              ? "active"
              : "",
          DentEditCertificateContentsJa:
            this.getRoutePath().includes(RouterEnum.Dent.path) &&
            this.getRouteName() ===
              `${RouterEnum.DentEditCertificateContents.name}${RouterEnum.Ja.name}`
              ? "active"
              : "",
          OphEditCertificateContentsList:
            this.getRoutePath().includes(RouterEnum.Oph.path) &&
            this.getRoutePath().includes(
              RouterEnum.OphEditCertificateContentsList.path
            )
              ? "active"
              : "",
          PsEditCertificateContents:
            this.getRoutePath().includes(RouterEnum.Ps.path) &&
            this.getRoutePath().includes(
              RouterEnum.PsEditCertificateContents.path
            )
              ? "active"
              : "",
          DermEditCertificateContents:
            this.getRoutePath().includes(RouterEnum.Derm.path) &&
            this.getRoutePath().includes(
              RouterEnum.DermEditCertificateContents.path
            )
              ? "active"
              : "",
          ImEditCertificateContents:
            this.getRoutePath().includes(RouterEnum.Im.path) &&
            this.getRoutePath().includes(
              RouterEnum.ImEditCertificateContents.path
            )
              ? "active"
              : "",
          OsEditCertificateContents:
            this.getRoutePath().includes(RouterEnum.Os.path) &&
            this.getRoutePath().includes(
              RouterEnum.OsEditCertificateContents.path
            )
              ? "active"
              : "",
          CommonEditCertificateContents:
            this.getRoutePath().includes(RouterEnum.Common.path) &&
            this.getRoutePath().includes(
              RouterEnum.CommonEditCertificateContents.path
            )
              ? "active"
              : "",
          VetEditCertificateContents:
            this.getRoutePath().includes(RouterEnum.Vet.path) &&
            this.getRoutePath().includes(
              RouterEnum.VetEditCertificateContents.path
            )
              ? "active"
              : "",
          HospitalInfo: this.getRoutePath().includes(
            RouterEnum.HospitalInfo.path
          )
            ? "active"
            : "",
          SubAccountManagement: this.getRoutePath().includes(
            RouterEnum.SubAccountManagement.path
          )
            ? "active"
            : "",
          Notices: this.getRoutePath().includes(RouterEnum.Notices.path)
            ? "active"
            : "",
          ElectronicSign: this.getRoutePath().includes(
            RouterEnum.ElectronicSign.path
          )
            ? "active"
            : "",
          AlimtalkChannelSettings:
            this.getRouteName() === RouterEnum.Alimtalk.ChannelSettings.name
              ? "active"
              : "",
        },
      };
    },
  },
  methods: {
    convertProfile,
    // 묶음 안 항목 보임(새 규칙 날에만 항목 코드로)
    subMenu(key) {
      return subMenuVisible(permState.modes, permState.perms, key);
    },
    async checkPrimaryChannel() {
      try {
        const response = await alimtalkChannelService.getPrimaryChannel();
        this.hasPrimaryChannel = response.success && !!response.data;
      } catch (error) {
        console.error("Failed to check primary channel:", error);
        this.hasPrimaryChannel = false;
      }
    },
    handleAlimtalkMenuClick(routeName) {
      if (!this.hasPrimaryChannel) {
        return;
      }
      this.$router.push({ name: routeName });
    },
    // studio 로 1회용 코드 이동(K-17 — 옛 토큰 쿼리 링크 대체). 지원 탭이면 서버가 같은 사람으로 studio 지원 세션을 새로 엶(D1 11-01)
    async goToStudio(path = "") {
      try {
        await openStudio(path ? `/${path}` : "/");
      } catch (error) {
        if (!alreadyNotified(error)) this.$message.error("스튜디오로 이동하지 못했습니다. 잠시 후 다시 시도해 주세요.");
      }
    },
    async goToVoicebotAdmin() {
      try {
        const companyId = jwtDecoder(getAccessToken());
        const success = await openVoicebotAdmin(companyId);
        if (!success) {
          this.$message.error("음성봇 관리자 로그인에 실패했습니다.");
        }
      } catch (error) {
        console.error("음성봇 SSO 로그인 오류:", error);
        this.$message.error(
          "음성봇 서비스 연결에 실패했습니다. 잠시 후 다시 시도해주세요."
        );
      }
    },
    modalHandler(modalType, action) {
      switch (modalType) {
        case "qrLoginModal":
          this.isQrModalShowing = action;
          return;
      }
    },
    getDentCertificateSettingComponentName(hasDept) {
      const deptType = MedicalDept.DENT;
      if (!hasDept) return "";

      const surgeryTypes = getAvailableSurgeryTypes(this.companyInfo, deptType);
      if (surgeryTypes.length > 1) {
        switch (deptType) {
          case MedicalDept.DENT:
            return RouterEnum.DentEditCertificateContentsList.name;
        }
      }

      switch (deptType) {
        case MedicalDept.DENT:
          if (surgeryTypes.length === 0) {
            return RouterEnum.DentEditCertificateContents.name;
          }
          if (surgeryTypes.length === 1 && surgeryTypes.includes("IMPLANT")) {
            return RouterEnum.DentEditCertificateContents.name;
          }
          if (surgeryTypes.length === 1 && surgeryTypes.includes("ABUTMENT")) {
            return RouterEnum.DentAbutmentEditCertificateContents.name;
          }
          if (surgeryTypes.length === 1 && surgeryTypes.includes("BRACE")) {
            return RouterEnum.DentBraceEditCertificateContents.name;
          }
          if (surgeryTypes.length === 1 && surgeryTypes.includes("ZIRCONIA")) {
            return RouterEnum.DentZirconiaEditCertificateContents.name;
          }
          return RouterEnum.DentEditCertificateContentsList.name;
      }

      return "";
    },
    getRoutePath() {
      return this.$route.path;
    },
    getRouteName() {
      return this.$route.name;
    },
  },
};
</script>
